module.exports = __webpack_public_path__ + "static/l4-1def841bfd9d7dd637435b6e4921506c.jpg";